export default "__VITE_ASSET__DgJcUZDW__"